// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w04bCdJ7M_RFWKSEJJfS{width:100%;height:100%;overflow:hidden auto;z-index:9999;position:fixed;top:0;background:#fff}.w04bCdJ7M_RFWKSEJJfS.WOoC3ivNdU54BnVRYAsi{width:368px;top:auto;right:0}.w04bCdJ7M_RFWKSEJJfS.p_cDlG8vqMWyEf1ghkVB{width:272px;height:544px;bottom:0;right:8px;border-radius:8px 8px 0px 0px;box-shadow:0px 0px 16px 0px rgba(0,0,0,.16)}.KEjiS7GuvniniNjSxVVG{animation:xdxRA5BzNqqp0NflMwx4 .3s ease-out forwards}.pAP8oMOggGOjcLSILGFi{animation:CZlRn2kESJTgaY5pemcT .3s ease-in forwards}@keyframes xdxRA5BzNqqp0NflMwx4{from{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes CZlRn2kESJTgaY5pemcT{from{transform:translateY(0)}to{transform:translateY(100%)}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagingContainer": `w04bCdJ7M_RFWKSEJJfS`,
	"desktop": `WOoC3ivNdU54BnVRYAsi`,
	"desktopInbox": `p_cDlG8vqMWyEf1ghkVB`,
	"slideUp": `KEjiS7GuvniniNjSxVVG`,
	"slideUpAnimation": `xdxRA5BzNqqp0NflMwx4`,
	"slideDown": `pAP8oMOggGOjcLSILGFi`,
	"slideDownAnimation": `CZlRn2kESJTgaY5pemcT`
};
export default ___CSS_LOADER_EXPORT___;
